if (!customElements.get('read-more')) {
  customElements.define(
    'read-more',
    class ReadMore extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('.read-more__content');
        this.toggle = this.querySelector('.read-more__toggle');
        if (!this.content || !this.toggle) return;

        this.onToggleClick = this.onToggleClick.bind(this);
        this.toggle.addEventListener('click', this.onToggleClick);
        this.classList.add('read-more--collapsed');

        // Re-measure when the column width or fonts change, so short text never shows the toggle.
        // The update runs on the next frame because it can resize the observed element.
        this.resizeObserver = new ResizeObserver(() => requestAnimationFrame(() => this.update()));
        this.resizeObserver.observe(this.content);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.toggle?.removeEventListener('click', this.onToggleClick);
      }

      onToggleClick() {
        const expanded = this.toggle.getAttribute('aria-expanded') === 'true';
        this.toggle.setAttribute('aria-expanded', String(!expanded));
        this.classList.toggle('read-more--collapsed', expanded);
      }

      update() {
        const style = getComputedStyle(this.content);
        const lines = parseFloat(style.getPropertyValue('--read-more-lines')) || 4;
        const overflowing = this.content.scrollHeight > lines * parseFloat(style.lineHeight) + 1;

        this.classList.toggle('read-more--overflowing', overflowing);
        this.toggle.hidden = !overflowing;
      }
    }
  );
}
